import React from "react";
import Button from "../Button";
import "./MemoryResult.scss";

const MemoryResult = ({
  title,
  description,
  buttonText,
  onButtonClick,
  buttonColor,
  matchedCount,
  totalPairs,
  client,
}) => {
  return (
    <div className="MemoryResult">
      <h2>{title}</h2>
      <p>{description}</p>
      {client === "airfrance" ? (
        <div className="match-progress">
          <strong>Congratulations!</strong>
          <br />
          <strong>
            You matched {matchedCount} / {totalPairs} pairs!
          </strong>
          <br /> <br />
          Enjoy your gift from Air France and join us soon to enjoy the many
          amenities offered in Premium.
        </div>
      ) : (
        <div className="match-progress">
          Matched {matchedCount} / {totalPairs} pairs
        </div>
      )}
      <Button
        onClick={onButtonClick}
        style={{ backgroundColor: buttonColor || undefined, color: "#fff" }}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default MemoryResult;
